<div class="pb-3 pt-3 px-3">
    <h1>{{ _i18n._9746_TABLE_EDITOR_ADMINISTRATION | translate }}</h1>
</div>

<div class="pb-3 px-3">
    <cmps-container>
        <cmps-container-header>
            <span>{{ _i18n._9747_TABLE_SELECTION | translate }}</span>
        </cmps-container-header>
        <cmps-container-content>
            <div class="cmps-admin-table-editor--table">
                <div class="cmps-admin-table-editor--row">
                    <div class="cmps-admin-table-editor--cell-40">
                        {{ _i18n._9749_TABLE | translate }}
                    </div>
                    <div class="cmps-admin-table-editor--cell-50">
                        {{ _i18n._9301_DESCRIPTION | translate }}
                    </div>
                    <div class="cmps-admin-table-editor--cell-10"></div>
                </div>
                <div class="cmps-admin-table-editor--tables-container">
                    <ng-container *ngFor="let i of state?.tables">
                        <div class="cmps-admin-table-editor--row">
                            <div class="cmps-admin-table-editor--cell-40">
                                {{ i.displayName }}
                            </div>
                            <div class="cmps-admin-table-editor--cell-50">
                                {{ i.description }}
                            </div>
                            <div class="cmps-admin-table-editor--cell-10">
                                <button
                                    cmpsIconButton
                                    [disabled]="
                                        state?.pending?.create ||
                                        state?.pending?.delete != null
                                    "
                                    (click)="_onEditTableClick(i)"
                                    *ngIf="_canEdit || _canDelete || _canAdd"
                                >
                                    <cmps-icon svgIcon="pencil"></cmps-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>

<div
    class="pb-3 px-3"
    *ngIf="state?.table && state?.rows"
>
    <cmps-container>
        <cmps-container-header>
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    {{ _i18n._9748_TABLE_INFORMATION_FOR_ | translate }}
                    {{ state?.table?.displayName }}
                </div>
                <div
                    [class.invisible]="_formVisible"
                    *ngIf="_canAdd"
                >
                    <button
                        cmpsIconButton
                        [disabled]="_formVisible"
                        (click)="_onNewRowClick()"
                    >
                        <cmps-icon svgIcon="plus"></cmps-icon>
                    </button>
                </div>
            </div>
        </cmps-container-header>
        <cmps-container-content>
            <!--replace with toasts when available in uikit-->
            <div *ngIf="state?.message">
                {{ state?.message | translate }}
            </div>

            <div class="cmps-admin-table-editor--table">
                <div class="cmps-admin-table-editor--row">
                    <!--more than 9 columns is not implemented-->
                    <ng-container *ngFor="let c of state?.table?.columns">
                        <div class="cmps-admin-table-editor--cell-10">
                            {{ c.columnName }}
                        </div>
                    </ng-container>
                    <div></div>
                </div>
                <div
                    class="cmps-admin-table-editor--row"
                    *ngIf="_form && _formVisible"
                >
                    <ng-container [formGroup]="_form">
                        <ng-container
                            *ngFor="let c of _form?.controls | keyvalue"
                        >
                            <div class="cmps-admin-table-editor--cell-10">
                                <!--variance for different variableTypes is not implemented-->
                                <input [formControlName]="c.key" />
                            </div>
                        </ng-container>
                        <div class="pb-1">
                            <button
                                cmpsIconButton
                                [disabled]="state?.pending?.create"
                                (click)="_onCreateRowClick()"
                                *ngIf="_canAdd"
                            >
                                <cmps-icon svgIcon="content-save"></cmps-icon>
                            </button>
                            <button
                                class="ml-2 cmps-icon-button--no-bg"
                                cmpsIconButton
                                [disabled]="state?.pending?.create"
                                (click)="_onCancelCreateRowClick()"
                            >
                                <cmps-icon svgIcon="close"></cmps-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
                <div class="cmps-admin-table-editor--rows-container">
                    <ng-container *ngFor="let i of state?.rows; let ii = index">
                        <div class="cmps-admin-table-editor--row">
                            <ng-container
                                *ngFor="let c of state?.table?.columns"
                            >
                                <div class="cmps-admin-table-editor--cell-10">
                                    {{ state?.rowViews[ii][c.columnName] }}
                                </div>
                            </ng-container>
                            <div class="pb-1">
                                <!--editing is not implemented-->
                                <button
                                    cmpsIconButton
                                    [disabled]="state?.pending?.delete === ii"
                                    (click)="_onDeleteRowClick(i)"
                                    *ngIf="_canDelete"
                                >
                                    <cmps-icon svgIcon="delete"></cmps-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
